module.exports = __webpack_public_path__ + "static/sport/bgi-h5.d17fb26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport5/bgi-h5.png
// module id = Hi2X
// module chunks = 0